module.exports = __webpack_public_path__ + "media/assets/images/landings/workforce/screens/workforce_log_reminder-80bf2de65926364bbcd513e1f29b673d.png";